import React from 'react';
import styled from '@emotion/styled';
import { Theme } from 'ui_system/theme';

function CircleMinusIcn(props) {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="26px"
      height="26px"
      viewBox="0 0 26 26"
      style={{ enableBackground: 'new 0 0 26 26' }}
      xmlSpace="preserve"
      {...props}
    >
      <style type="text/css" />
      <path
        id="XMLID_6_"
        className="st0"
        d="M13,26C5.8,26,0,20.2,0,13S5.8,0,13,0s13,5.8,13,13S20.2,26,13,26z M13,2C6.9,2,2,6.9,2,13
      	s4.9,11,11,11s11-4.9,11-11S19.1,2,13,2z"
      />
      <rect
        id="XMLID_7_"
        x={7}
        y="12.5"
        className="st0"
        width={12}
        height={2}
      />
    </svg>
  );
}

const CircleMinusIcon = styled(CircleMinusIcn)`
  fill: ${(props) => props.color || Theme.colors.linksDesignElementsBaseColor};
`;

export default CircleMinusIcon;
